"use strict";

import * as Departments from '../api/departments/departments'
import { getDepartmentProducts } from '../api/departments/departments'

export default {
    state: {
        departmentsProductsResource: {},
        departments: [],
        currentDepartment: {
            "id": 13,
            "parent_id": 25,
            "level": 1,
            "slug": "complete-lights",
            "name": "Complete Lights",
            "image": "Adjust-a-Wing-Kit.png",
            "created_at": "2009-02-07 17:05:00",
            "updated_at": "2014-05-18 12:26:49",
            "deleted_at": null,
            "children": [],
            "products": [ {
                "id": 3000,
                "parent_id": null,
                "brand": 0,
                "level": 0,
                "upgrade": 0,
                "name": "TechOne Dimmable SuperLumen Kit",
                "sub_heading": null,
                "slug": "techone-dimmable-superlumen-kit",
                "wholesale_name": "",
                "description": "These digital ballast have four power settings Super 700w 600w 400w and 250w All dimmable using a 600w Sodium or Metal Halide Bulb Flowering Kit comes with a Propagrow Mixed Spectrum Bulb Vegetative Kit come with a Venture Metal Halide Bulb",
                "photo": "techone super lrg.jpg",
                "price": 16000,
                "units": 1,
                "current_stock": 0,
                "maximum_stock": null,
                "reorder_level": null,
                "minimum_order": null,
                "weight": 10,
                "weeks": null,
                "ec": null,
                "recommended": true,
                "selected": null,
                "special_offer": false,
                "heavy": false,
                "till_name": null,
                "till_price": 0,
                "notes": null,
                "created_at": "2012-12-18 16:12:36",
                "updated_at": "2018-11-03 12:39:21",
                "deleted_at": null,
                "n_grams": "__T _Te Tec ech chO hOn One ne  e D  Di Dim imm mma mab abl ble le  e S  Su Sup upe per erL rLu Lum ume men en  n K  Ki Kit it_ t__",
                "search_index": 1,
                "auto_order": false,
                "full_name": "TechOne Dimmable SuperLumen Kit",
                "has_kit": false,
                "pivot": {
                    "departments_id": 13,
                    "products_id": 3000,
                    "level": 1,
                    "created_at": "2014-04-18 13:42:03",
                    "updated_at": "2016-03-31 18:14:15"
                },
                "suppliers": [],
                "children": [ {
                    "id": 3001,
                    "parent_id": 3000,
                    "brand": 0,
                    "level": 0,
                    "upgrade": 0,
                    "name": "Propagrow Bulb",
                    "sub_heading": null,
                    "slug": "techone-dimmable-superlumen-kit-propagrow-bulb",
                    "wholesale_name": "",
                    "description": "",
                    "photo": "techone super lrg.jpg",
                    "price": 10000,
                    "units": 1,
                    "current_stock": 0,
                    "maximum_stock": null,
                    "reorder_level": null,
                    "minimum_order": null,
                    "weight": 10,
                    "weeks": null,
                    "ec": null,
                    "recommended": false,
                    "selected": null,
                    "special_offer": false,
                    "heavy": false,
                    "till_name": null,
                    "till_price": 0,
                    "notes": null,
                    "created_at": "2012-12-18 16:24:10",
                    "updated_at": "2018-11-03 12:39:21",
                    "deleted_at": null,
                    "n_grams": "__P _Pr Pro rop opa pag agr gro row ow  w B  Bu Bul ulb lb_ b__",
                    "search_index": 1,
                    "auto_order": false,
                    "full_name": "TechOne Dimmable SuperLumen Kit - Propagrow Bulb",
                    "has_kit": true,
                    "suppliers": [],
                    "parent": {
                        "id": 3000,
                        "parent_id": null,
                        "brand": 0,
                        "level": 0,
                        "upgrade": 0,
                        "name": "TechOne Dimmable SuperLumen Kit",
                        "sub_heading": null,
                        "slug": "techone-dimmable-superlumen-kit",
                        "wholesale_name": "",
                        "description": "These digital ballast have four power settings Super 700w 600w 400w and 250w All dimmable using a 600w Sodium or Metal Halide Bulb Flowering Kit comes with a Propagrow Mixed Spectrum Bulb Vegetative Kit come with a Venture Metal Halide Bulb",
                        "photo": "techone super lrg.jpg",
                        "price": 16000,
                        "units": 1,
                        "current_stock": 0,
                        "maximum_stock": null,
                        "reorder_level": null,
                        "minimum_order": null,
                        "weight": 10,
                        "weeks": null,
                        "ec": null,
                        "recommended": true,
                        "selected": null,
                        "special_offer": false,
                        "heavy": false,
                        "till_name": null,
                        "till_price": 0,
                        "notes": null,
                        "created_at": "2012-12-18 16:12:36",
                        "updated_at": "2018-11-03 12:39:21",
                        "deleted_at": null,
                        "n_grams": "__T _Te Tec ech chO hOn One ne  e D  Di Dim imm mma mab abl ble le  e S  Su Sup upe per erL rLu Lum ume men en  n K  Ki Kit it_ t__",
                        "search_index": 1,
                        "auto_order": false,
                        "full_name": "TechOne Dimmable SuperLumen Kit",
                        "has_kit": false,
                        "kit": []
                    },
                    "kit": [ {
                        "id": 2999,
                        "parent_id": null,
                        "brand": 0,
                        "level": 0,
                        "upgrade": 0,
                        "name": "600w Red SuperLumen TechOne Dimmable Ballast",
                        "sub_heading": null,
                        "slug": "600w-red-superlumen-techone-dimmable-ballast",
                        "wholesale_name": "",
                        "description": "A welcome addition to the TechOne family with an extra power setting These ballast have four power settings Super Lumen 600w 400w and 250w dimmable all off a 600w bulb Sodium or Metal Halide it does not matter Even with their great reputation TechOne still offer a 12 month warranty",
                        "photo": "mk3 techone lrg.jpg",
                        "price": 9000,
                        "units": 1,
                        "current_stock": -174,
                        "maximum_stock": null,
                        "reorder_level": null,
                        "minimum_order": null,
                        "weight": 10,
                        "weeks": null,
                        "ec": null,
                        "recommended": true,
                        "selected": null,
                        "special_offer": false,
                        "heavy": false,
                        "till_name": null,
                        "till_price": null,
                        "notes": null,
                        "created_at": "2012-12-14 12:01:15",
                        "updated_at": "2018-11-11 11:10:51",
                        "deleted_at": null,
                        "n_grams": "__6 _60 600 00w 0w  w R  Re Red ed  d S  Su Sup upe per erL rLu Lum ume men en  n T  Te Tec ech chO hOn One ne  e D  Di Dim imm mma mab abl ble le  e B  Ba Bal all lla las ast st_ t__",
                        "search_index": 1,
                        "auto_order": false,
                        "full_name": "600w Red SuperLumen TechOne Dimmable Ballast",
                        "has_kit": false,
                        "pivot": { "parent_id": 3001, "child_id": 2999, "units": 1 },
                        "kit": []
                    }, {
                        "id": 2264,
                        "parent_id": 1444,
                        "brand": 91,
                        "level": 1,
                        "upgrade": 1,
                        "name": "600w",
                        "sub_heading": null,
                        "slug": "propagrow-mixed-spectrum-bulb-600w",
                        "wholesale_name": "",
                        "description": "",
                        "photo": "bulb.jpg",
                        "price": 2000,
                        "units": 1,
                        "current_stock": 4317,
                        "maximum_stock": null,
                        "reorder_level": null,
                        "minimum_order": null,
                        "weight": 1,
                        "weeks": null,
                        "ec": null,
                        "recommended": false,
                        "selected": true,
                        "special_offer": false,
                        "heavy": false,
                        "till_name": null,
                        "till_price": null,
                        "notes": null,
                        "created_at": "2011-04-27 13:56:14",
                        "updated_at": "2018-11-13 17:22:45",
                        "deleted_at": null,
                        "n_grams": "__6 _60 600 00w 0w_ w__",
                        "search_index": 1,
                        "auto_order": false,
                        "full_name": "Propagrow Mixed Spectrum Bulb - 600w",
                        "has_kit": false,
                        "pivot": { "parent_id": 3001, "child_id": 2264, "units": 1 },
                        "parent": {
                            "id": 1444,
                            "parent_id": null,
                            "brand": 0,
                            "level": 0,
                            "upgrade": 0,
                            "name": "Propagrow Mixed Spectrum Bulb",
                            "sub_heading": null,
                            "slug": "propagrow-mixed-spectrum-bulb",
                            "wholesale_name": "",
                            "description": "The Mixed Spectrum Sodium Propagrow Lamp has been designed for horticultural use and promotes optimum plant growth Propagrow Lamps have been colour adjusted to provide a much broader spectrum of light which makes them perform exceptionally well in both the vegetative and flowering stages Highest output ever recorded for 600w Bulb 98 000 Lumens even better than Grolux or Sunmaster",
                            "photo": "bulb.jpg",
                            "price": 2500,
                            "units": 1,
                            "current_stock": 0,
                            "maximum_stock": null,
                            "reorder_level": null,
                            "minimum_order": null,
                            "weight": 1,
                            "weeks": null,
                            "ec": null,
                            "recommended": false,
                            "selected": null,
                            "special_offer": false,
                            "heavy": false,
                            "till_name": null,
                            "till_price": 0,
                            "notes": null,
                            "created_at": "2011-04-27 13:56:14",
                            "updated_at": "2018-11-13 17:22:45",
                            "deleted_at": null,
                            "n_grams": "__P _Pr Pro rop opa pag agr gro row ow  w m  mi mix ixe xed ed  d s  sp spe pec ect ctr tru rum umL mLa Lam amp mp_ p__",
                            "search_index": 1,
                            "auto_order": false,
                            "full_name": "Propagrow Mixed Spectrum Bulb",
                            "has_kit": false,
                            "kit": []
                        },
                        "kit": []

                    } ]
                } ],
            } ],
        }
    },
    getters: {
        currentDepartmentHasChildren: state => {
            return ( state.currentDepartment.children ) ? ( state.currentDepartment.children.length > 0 ) : false;
        },

        currentDepartmentProducts: ( state, getters ) => {
            return ( state.currentDepartment.products && state.currentDepartment.products.length > 0 )
                ? state.currentDepartment.products : [];
        },

        currentDepartment: state => {
            return state.currentDepartment;
        },

        departmentsProductsResource: state => {
            return state.departmentsProductsResource;
        },

        departments: state => {
            return state.departments;
        }
    },

    mutations: {
        departments: ( state, departments ) => {
            state.departments = departments;
        },

        currentDepartment: ( state, currentDepartment ) => {
            state.currentDepartment = currentDepartment;
        },

        departmentsProductsResource: ( state, departmentsProductsResource ) => {
            state.departmentsProductsResource = departmentsProductsResource;
        },

        addProducts: ( state, products ) => {
            state.currentDepartment.products = products;
        }
    },

    actions: {
        /**
         * Gets and sets the department
         *
         * @param state the current state
         * @param commit all mutations
         * @param dispatch all actions
         * @param departmentSlug
         * @returns {Promise<any>}
         */
        currentDepartment: async ( { commit, dispatch }, departmentSlug ) => {
            try {
                let departmentResponse = await Departments.getDepartment( departmentSlug );
                let products = [];
                let department = departmentResponse.data;

                /**
                 * If a department doesn't have any products but has
                 * children get the products from the children
                 */
                if ( department.products.length < 1 && department.children.length > 0 ) {
                    for (let i = 0; i < 1; i++) {
                        let child = department.children[i];
                        let departmentProductsResponse = await getDepartmentProducts( child.slug );
                        products = products.concat( departmentProductsResponse.data.products );
                    }
                    department.products = products;
                }
                await commit( 'currentDepartment', department );
                return department;
            } catch ( e ) {
                console.error( e );
                return Promise.reject( 'Problem getting department' );
            }
        },

        /**
         * Gets all products from a department and adds them to the current department
         *
         * @param commit
         * @param departmentSlug
         */
        getDepartmentProducts: async ( { commit }, departmentSlug ) => {
            try {
                let departmentProductsResponse = await getDepartmentProducts( departmentSlug );
                await commit( 'addProducts', departmentProductsResponse.data.products );
            } catch ( e ) {
                console.error( error );
                return Promise.reject( 'Problem getting department products' );
            }
        },

        removeProductFromDepartment( { state, commit }, product ) {
            if ( product.parent_id !== null ) {
                let productToEdit = _.find( state.currentDepartment.products, { id: product.parent_id } );
                productToEdit.children = _.filter( productToEdit.children, function ( child ) {
                    return child.id !== product.id;
                } );
                _.$update( state.currentDepartment.products, { id: productToEdit.id }, productToEdit );
            } else {
                state.currentDepartment.products = _.filter( state.currentDepartment.products, function ( productToEdit ) {
                    return productToEdit.id !== product.id;
                } );
            }
        },
    }
}
